import { createFeature, createReducer, on, createSelector, createAction, props } from '@ngrx/store';
import { CommonApiState } from './common';
import { WorkspaceDocVersion } from '@workspaces/models/versions';

export const WorkspaceVersionFetch = createAction('[WorkspaceVersion] Fetch', props<{ workspaceId: string }>());
export const WorkspaceVersionFetched = createAction(
  '[WorkspaceVersion] Fetched',
  props<{ workspaceId: string; workspaceVersion: WorkspaceDocVersion[] }>()
);
export const WorkspaceVersionError = createAction('[WorkspaceVersion] Error', props<{ workspaceId: string }>());

export const initialState: Record<string, CommonApiState<WorkspaceDocVersion[]>> = {};

export const workspaceVersionFeature = createFeature({
  name: 'workspaceVersion',
  reducer: createReducer(
    initialState,
    on(WorkspaceVersionFetch, (state, action) => ({
      ...state,
      [action.workspaceId]: {
        ...(state[action.workspaceId] ?? {}),
        currentPedingApis: (state[action.workspaceId]?.currentPedingApis ?? 0) + 1
      }
    })),
    on(WorkspaceVersionFetched, (state, action) => {
      return {
        ...state,
        [action.workspaceId]: {
          ...(state[action.workspaceId] ?? {}),
          currentPedingApis: 0,
          data: action.workspaceVersion
        }
      };
    }),
    on(WorkspaceVersionError, (state, action) => {
      return {
        ...state,
        [action.workspaceId]: {
          ...(state[action.workspaceId] ?? {}),
          currentPedingApis: 0,
          isError: true
        }
      };
    })
  ),
  extraSelectors: ({ selectWorkspaceVersionState }) => {
    const workspaceVersionIsLoading = (workspaceId: string) =>
      createSelector(
        selectWorkspaceVersionState,
        workspaceVersionState => (workspaceVersionState[workspaceId]?.currentPedingApis ?? 0) > 0
      );

    const workspaceVersionHasPendingRequest = (workspaceId: string) =>
      createSelector(
        selectWorkspaceVersionState,
        workspaceVersionState => (workspaceVersionState[workspaceId]?.currentPedingApis ?? 0) >= 2
      );

    const workspaceVersionData = (workspaceId: string) => {
      return createSelector(selectWorkspaceVersionState, workspaceVersionState => {
        return workspaceVersionState[workspaceId]?.data;
      });
    };
    const workspaceVersionIsError = (workspaceId: string) => {
      return createSelector(selectWorkspaceVersionState, workspaceVersionState => {
        return workspaceVersionState[workspaceId]?.isError;
      });
    };

    return {
      workspaceVersionIsLoading: workspaceVersionIsLoading,
      workspaceVersionHasPendingRequest: workspaceVersionHasPendingRequest,
      workspaceVersionData: workspaceVersionData,
      workspaceVersionIsError
    };
  }
});
